class SizeChartTable extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('[data-unit]');
    this.cells = this.querySelectorAll('[data-cm]');
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.setUnit(button.dataset.unit, button));
    });
  }

  setUnit(unit, activeButton) {
    this.buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive);
    });

    this.cells.forEach((cell) => {
      const cm = parseFloat(cell.dataset.cm);
      if (Number.isNaN(cm)) return;
      cell.textContent = unit === 'in' ? this.formatNumber(cm / 2.54) : this.formatNumber(cm);
    });
  }

  formatNumber(value) {
    return (Math.round(value * 100) / 100).toString();
  }
}

customElements.define('size-chart-table', SizeChartTable);
